import { DeliveryStatusEnum } from '../../../../models/enums/delivery-status.enum';
import { AttributeFilter } from './attribute-filter';

export class DeliveryStatusAttributeFilter implements AttributeFilter {
  attribute: string;
  label: string;
  operator: string;
  value?: string[];
  tempValue?: string[] | undefined;
  secondValue?: any;

  constructor(attribute: string, label: string, operator: string, value?: string[], secondValue?: any) {
    this.attribute = attribute;
    this.label = label;
    this.operator = operator;
    this.value = value;
    this.secondValue = secondValue;
  }

  updateValue(): any {
    const filters = Object.create({});
    this.value = this.tempValue;
    filters[this.attribute + '.' + this.operator] = this.value;
    return filters;
  }

  isChecked(): boolean {
    if (this.tempValue && this.operator) {
      return true;
    } else {
      return false;
    }
  }

  htmlButtonText(): string {
    let htmlContent = '<b>' + this.label + '</b> ';
    if (this.operator === 'in') {
      htmlContent += 'est';
    } else {
      htmlContent += '';
    }

    if (this.value?.includes(DeliveryStatusEnum.DELIVERED)) {
      htmlContent += ' <b>Livré</b>';
    } else if (this.value?.includes(DeliveryStatusEnum.PROBLEM)) {
      htmlContent += ' <b>Non livré</b>';
    } else {
      htmlContent += ' <b>En cours de livraison</b>';
    }
    return htmlContent;
  }
}
